import styled from '@emotion/styled';
import { rem } from '@triumph/design-system';

import { DDDCardHeader } from '../../Applicant.StyledComponents';

const CARD_BORDER = '1px solid #e2e8f0';

// A collapsed card has no body under the header, so its divider would sit on the card's bottom edge.
export const CollapsibleCardHeader = styled(DDDCardHeader)<{ $collapsed: boolean }>`
    border-bottom: ${({ $collapsed }) => ($collapsed ? 'none' : '1px solid #e2e8f0')};
`;

export const CardToggle = styled.button`
    display: flex;
    align-items: center;
    gap: ${rem(8)};
    padding: 0;
    border: none;
    background: none;
    font: inherit;
    color: inherit;
    cursor: pointer;
    text-align: left;
`;

export const CardChevron = styled.span`
    width: ${rem(12)};

    @media print {
        display: none;
    }
`;

export const CardStateBody = styled.div`
    padding: ${rem(12)} ${rem(20)};
`;

// One account per block inside a source's card, divided like DDD card sections.
export const ApplicantItemWrapper = styled.div`
    & + & {
        border-top: ${CARD_BORDER};
    }
`;

export const ExternalLinkIcon = styled.span`
    display: inline-block;
    transform: rotate(90deg);
`;

export const SkeletonWrapper = styled.div`
    padding: ${rem(12)} ${rem(20)};
    border-top: ${CARD_BORDER};
`;

export const SkeletonItem = styled.div<{ marginBottom?: string; marginLeft?: string }>`
    margin-bottom: ${({ marginBottom }) => marginBottom || '0'};
    margin-left: ${({ marginLeft }) => marginLeft || '0'};
`;

export const LoadMoreTrigger = styled.div`
    height: ${rem(1)};
`;

export const EndOfListMessage = styled.div`
    text-align: center;
    color: #666;
    font-size: 0.9em;
    padding: ${rem(12)} ${rem(20)};
    border-top: ${CARD_BORDER};
`;

export const MatchedOnList = styled.ul`
    margin: 0;
    padding-left: ${rem(16)};
    list-style-type: disc;
`;
